import { Link } from "react-router-dom";
import PT from "../images/icons/PsychologyToday.png"
import email from "../images/icons/email.png"
// import { ReactComponent as Instagram } from "../images/svg/instagram.svg";
// import { ReactComponent as Facebook } from "../images/svg/facebook.svg";
// import { ReactComponent as Email } from "../images/svg/email.svg";

import "../styles/footer.scss";

const Footer = () => {

  return (
    <>
      <footer className="page-footer">
        <div className="socials">
          <Link to="https://www.psychologytoday.com/gb/counselling/marc-lahaye-london/1609335" target="_blank" rel="noopener noreferrer" ><img src={PT} alt="psychology today" className="footer-icon" /></Link>
          <Link to="/contact"><img src={email} alt="psychology today" className="footer-icon" /></Link>
          {/* <Link to="/contact"><Email className="svg-size" /></Link> */}
        </div>
      </footer>
    </>
  );
};

export default Footer;

// #395D3996
// https://icons8.com/icons/set/instagram--green